import styled, { css } from 'styled-components';
import { ReactComponent as Cross } from './cross.svg';

const Overlay = styled.section`
  top: 0;
  position: fixed;
  background: rgba(17, 17, 17, 0.7);
  backdrop-filter: blur(10px);
  width: 100vw;
  height: 100vh;

  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.7;
    }
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  background: white;
  border-radius: 5px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 460px;
  height: 540px;
  animation: fadeIn 0.5s ease-in-out forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  ${(props) =>
    props.mobileHeight &&
    css`
      @media (max-width: 800px) {
        height: ${props.mobileHeight}px;
        width: 100vw;
      }
    `}
`;

const Close = styled(Cross)`
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
`;

export const S = {
  Overlay,
  Container,
  Close,
};
